import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import DataTable from "react-data-table-component";
import Button from "@material-tailwind/react/Button";

export default function TableBonusReferralHistory({
  data,
  pending,
  detail
}) {

  const columns = [
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Total Turnover",
      selector: (row) => row.total_turnover,
      sortable: true,
    },
    {
      name: "Total Winlose",
      selector: (row) => row.total_winlose,
      sortable: true,
    },
    {
      name: "Total Bonus Referral Turnover",
      selector: (row) => row.total_bonus_turnover,
      sortable: true,
    },
    {
      name: "Total Bonus Referral Winlose",
      selector: (row) => row.total_bonus_winlose,
      sortable: true,
    },
    {
      name: "Detail",
      selector: (row) => (
        <Button
          onClick={(event) => {

            detail(row.date);
          }}
        >
          Detail
        </Button>
      ),
      sortable: true,
    },
  ];

  return (
    <>
      <Card className="mt-12">
        <CardHeader color="blueGray" contentPosition="left">
          <h2 className="text-white text-2xl">Bonus Referral History</h2>
        </CardHeader>
        <CardBody>
          <DataTable
            columns={columns}
            data={data}
            progressPending={pending}
            pagination
          />
        </CardBody>
      </Card>
    </>
  );
}
